import { IS_BIZ_USER } from 'reactApp/appHelpers/configHelpers';
import { isThemedSharedToobarItem } from 'reactApp/appHelpers/featuresHelpers/features/themedPublic';
import { disabledAll, STORAGE_CONFIG } from 'reactApp/modules/storage/storage.config.new';
import { EActions, EStorageType } from 'reactApp/modules/storage/storage.types';

export const TOOLBAR_CONFIG = {
    [EStorageType.home]: {
        ...STORAGE_CONFIG[EStorageType.home],
        [EActions.download]: 5,
        [EActions.remove]: isThemedSharedToobarItem ? 1 : 4,
        [EActions.publish]: 3,
        [EActions.publishAlbum]: 3,
        [EActions.unpublish]: 3,
        [EActions.share]: 2,
        [EActions.addToFavorites]: 1,
        [EActions.removeFromFavorites]: 1,
        [EActions.addToCustomAlbum]: 1,
        [EActions.addToVigboAlbum]: 1,
        [EActions.authorSort]: true,
        [EActions.newFeatures]: true,
        // tempexp_17340-start
        [EActions.changeDesign]: 4,
        [EActions.changeDesignMore]: true,
        // tempexp_17340-end
        // temmexp_18662-next-line
        [EActions.publicInfo]: true,
    },
    [EStorageType.trashbin]: {
        ...STORAGE_CONFIG[EStorageType.trashbin],
        [EActions.newFeatures]: true,
    },
    [EStorageType.recommend]: {
        ...STORAGE_CONFIG[EStorageType.recommend],
    },
    [EStorageType.attaches]: {
        ...disabledAll,
        [EActions.back]: true,
        [EActions.selectAll]: 1,
        [EActions.download]: 1,
        [EActions.view]: 4,
        [EActions.sendViaMail]: 3,
        [EActions.clone]: 4,
        [EActions.publish]: 1,
        [EActions.add]: 3,
        [EActions.sort]: IS_BIZ_USER,
    },
    [EStorageType.favorites]: {
        ...STORAGE_CONFIG[EStorageType.favorites],
        [EActions.download]: 2,
        [EActions.remove]: 1,
        [EActions.publish]: 4,
        [EActions.publishAlbum]: 2,
        [EActions.unpublish]: 3,
        [EActions.share]: 2,
        [EActions.addToFavorites]: 2,
        [EActions.removeFromFavorites]: 3,
        [EActions.addToCustomAlbum]: 2,
        [EActions.addToVigboAlbum]: 2,
        [EActions.newFeatures]: true,
    },
    [EStorageType.sharedIncoming]: {
        ...disabledAll,
        [EActions.share]: 3,
        [EActions.remove]: 1,
        [EActions.download]: 5,
        [EActions.selectAll]: 1,
        [EActions.mount]: 3,
        [EActions.add]: 4,
        [EActions.sort]: IS_BIZ_USER,
        [EActions.back]: 1,
        [EActions.newFeatures]: 1,
    },
    [EStorageType.sharedLinks]: {
        ...STORAGE_CONFIG[EStorageType.sharedLinks],
        [EActions.download]: 1,
        [EActions.publish]: 2,
        [EActions.publishAlbum]: 2,
        [EActions.unpublish]: 2,
        [EActions.share]: 3,
        [EActions.addToCustomAlbum]: 1,
        [EActions.addToVigboAlbum]: 1,
        [EActions.newFeatures]: true,
    },
    [EStorageType.sharedAutodelete]: {
        ...STORAGE_CONFIG[EStorageType.sharedAutodelete],
        [EActions.download]: 1,
        [EActions.publish]: 2,
        [EActions.unpublish]: 2,
        [EActions.newFeatures]: true,
    },
    [EStorageType.search]: {
        ...STORAGE_CONFIG[EStorageType.search],
        [EActions.download]: 4,
        [EActions.publish]: 3,
        [EActions.unpublish]: 3,
        [EActions.share]: 2,
        [EActions.remove]: 2,
        [EActions.addToFavorites]: 1,
        [EActions.removeFromFavorites]: 1,
        [EActions.newFeatures]: true,
    },
    [EStorageType.feed]: {
        ...STORAGE_CONFIG[EStorageType.feed],
        [EActions.download]: 3,
        [EActions.publish]: 1,
        [EActions.publishAlbum]: 1,
        [EActions.unpublish]: 1,
        [EActions.remove]: 2,
        [EActions.addToCustomAlbum]: 1,
        [EActions.addToVigboAlbum]: 1,
        [EActions.newFeatures]: true,
    },
    [EStorageType.gallery]: {
        ...STORAGE_CONFIG[EStorageType.gallery],
        [EActions.addToFavorites]: 1,
        [EActions.removeFromFavorites]: 1,
        [EActions.publish]: 2,
        [EActions.publishAlbum]: 2,
        [EActions.unpublish]: 2,
        [EActions.addToCustomAlbum]: 1,
        [EActions.addToVigboAlbum]: 1,
        [EActions.newFeatures]: true,
    },
    [EStorageType.alldocuments]: {
        ...STORAGE_CONFIG[EStorageType.feed],
        [EActions.download]: 3,
        [EActions.publish]: 1,
        [EActions.publishAlbum]: 1,
        [EActions.unpublish]: 1,
        [EActions.remove]: 2,
        [EActions.addToCustomAlbum]: 1,
        [EActions.addToVigboAlbum]: 1,
    },
    [EStorageType.documents]: {
        ...STORAGE_CONFIG[EStorageType.documents],
        [EActions.download]: 3,
        [EActions.publish]: 1,
        [EActions.publishAlbum]: 1,
        [EActions.unpublish]: 1,
        [EActions.addToFavorites]: 2,
        [EActions.removeFromFavorites]: 2,
        [EActions.addToCustomAlbum]: 1,
        [EActions.addToVigboAlbum]: 1,
        [EActions.newFeatures]: true,
    },
    [EStorageType.templates]: {
        ...STORAGE_CONFIG[EStorageType.templates],
        [EActions.newFeatures]: true,
    },
    [EStorageType.public]: {
        ...STORAGE_CONFIG[EStorageType.public],
        [EActions.remove]: 1,
        [EActions.download]: 2,
        [EActions.clone]: 3,
        [EActions.add]: false,
        [EActions.authorSort]: true,
    },
    [EStorageType.stock]: {
        ...STORAGE_CONFIG[EStorageType.stock],
        [EActions.remove]: 1,
        [EActions.download]: 2,
        [EActions.clone]: 3,
    },
    [EStorageType.quotaCleaner]: {
        ...STORAGE_CONFIG[EStorageType.quotaCleaner],
        delete: true,
        [EActions.selectAll]: true,
        [EActions.back]: true,
        [EActions.yearFilter]: true,
    },
    [EStorageType.albums]: {
        ...STORAGE_CONFIG[EStorageType.albums],
        [EActions.remove]: 3,
        [EActions.publish]: 2,
        [EActions.unpublish]: 2,
        [EActions.download]: 1,
        [EActions.addToFavorites]: 2,
        [EActions.removeFromFavorites]: 2,
        [EActions.addToCustomAlbum]: 2,
        [EActions.selectAll]: true,
        [EActions.back]: true,
        [EActions.createAlbum]: true,
    },
    [EStorageType.start]: {
        ...STORAGE_CONFIG[EStorageType.start],
        [EActions.publish]: 1,
        [EActions.unpublish]: 1,
        [EActions.share]: 2,
        [EActions.addToFavorites]: 3,
        [EActions.removeFromFavorites]: 3,
        [EActions.copy]: 3,
        [EActions.move]: 4,
        [EActions.history]: 5,
        [EActions.remove]: 5,
    },
    [EStorageType.vigbo]: {
        ...STORAGE_CONFIG[EStorageType.vigbo],
        [EActions.remove]: 3,
        [EActions.publish]: 2,
        [EActions.unpublish]: 2,
        [EActions.download]: 1,
        [EActions.addToFavorites]: 2,
        [EActions.removeFromFavorites]: 2,
        [EActions.addToVigboAlbum]: 2,
        [EActions.selectAll]: true,
        [EActions.back]: true,
        [EActions.createAlbum]: true,
    },
    [EStorageType.integration]: STORAGE_CONFIG[EStorageType.integration],
    [EStorageType.inlineIntegration]: STORAGE_CONFIG[EStorageType.inlineIntegration],
    [EStorageType.incomingPublic]: STORAGE_CONFIG[EStorageType.incomingPublic],
};

export const moreListOrder = [
    EActions.addToFavorites,
    EActions.removeFromFavorites,
    EActions.copy,
    EActions.move,
    EActions.rename,
    EActions.history,
    // tempexp_17340-next-line
    EActions.changeDesignMore,
    // temmexp_18662-next-line
    EActions.publicInfo,
    EActions.remove,
    EActions.complain,
];
export const actionsOrder = [
    EActions.back,
    EActions.selectAll,
    EActions.restoreAll,
    EActions.restore,
    EActions.clear,
    EActions.clone,
    EActions.sendViaMail,
    EActions.publish,
    EActions.publishAlbum,
    EActions.unpublish,
    EActions.share,
    EActions.addToFavorites,
    EActions.removeFromFavorites,
    EActions.mount,
    EActions.createAlbum,
    EActions.createVigboGallery,
    EActions.goToVigbo,
    EActions.addToCustomAlbum,
    EActions.addToVigboAlbum,
    EActions.download,
    EActions.copy,
    EActions.move,
    EActions.history,
    EActions.remove,
    // tempexp_17340-next-line
    EActions.changeDesign,
    EActions.more,
];
export const actionsOrder_PdfEdit = [
    EActions.back,
    EActions.addToFavorites,
    EActions.removeFromFavorites,
    EActions.download,
    EActions.publish,
    EActions.unpublish,
];

export const actionsOrder_EbookReader = [
    EActions.back,
    EActions.publish,
    EActions.addToFavorites,
    EActions.removeFromFavorites,
    EActions.download,
    EActions.unpublish,
];

export type TToolbarItemsKeys =
    | EActions.back
    | EActions.upload
    | EActions.create
    | EActions.selectAll
    | EActions.download
    | EActions.publish
    | EActions.unpublish
    | EActions.share
    | EActions.remove
    | EActions.removeFromFavorites
    | EActions.view
    | EActions.sort
    | EActions.sendViaMail
    | EActions.more
    | EActions.restore
    | EActions.restoreAll
    | EActions.clear
    | EActions.mount
    | EActions.clone
    | EActions.publishAlbum
    | EActions.addToVigboAlbum
    | EActions.addToCustomAlbum
    | EActions.createAlbum
    // tempexp_17340-next-line
    | EActions.changeDesign
    | EActions.createVigboGallery
    | EActions.goToVigbo
    | EActions.watchVigboGallery
    | EActions.setupVigboGallery;

export type TToolbarDropdownItemsKeys =
    | EActions.copy
    | EActions.uploadFile
    | EActions.uploadFolder
    | EActions.history
    | EActions.move
    | EActions.rename
    | EActions.viewThumbs
    | EActions.viewList
    | EActions.viewGallery
    | EActions.sortDate
    | EActions.sortSize
    | EActions.sortName
    | EActions.createCell
    | EActions.createDoc
    | EActions.createPpt
    | EActions.createFolder
    | EActions.addToFavorites
    | EActions.removeFromFavorites
    // tempexp_17340-next-line
    | EActions.changeDesignMore
    // temmexp_18662-next-line
    | EActions.publicInfo
    | EActions.complain
    | EActions.makeFamilyFolder
    | EActions.remove;

export type TToolbarStartPageItemsKeys =
    | EActions.copy
    | EActions.history
    | EActions.move
    | EActions.addToFavorites
    | EActions.removeFromFavorites;
